import { translate } from '../../../Services/translation';
import { string, object, boolean, mixed, bool } from 'yup';
import {
  CHECKOUT_DROPSHIP_COMPANY,
  CHECKOUT_DROPSHIP_PRIVATE,
} from '../../../constants';

const requiredTranslation = translate('validation.required');

export const alwaysRequiredSchema = object().shape({
  acceptTermsOfCondition: boolean()
    .required(translate('validation.checkrequired'))
    .oneOf([true]),
  selectedDeliveryMethod: object().required(requiredTranslation),
  selectedPaymentMethod: object().required(requiredTranslation),
});

export const privateCustomerAddressSchema = object().shape({
  lastName: string().nullable().required(requiredTranslation),
  firstName: string().nullable().required(requiredTranslation),
  address: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      36,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.address').replace('*', '')
        )
        .replace('{1}', '36')
    ),
  zipCode: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      10,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.zipcode').replace('*', '')
        )
        .replace('{1}', '10')
    ),
  city: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      36,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.city').replace('*', '')
        )
        .replace('{1}', '36')
    ),
  country: mixed()
    .nullable()
    .required(requiredTranslation)
    .notOneOf([''], requiredTranslation),
  phoneNumber: string().nullable().required(requiredTranslation),
  email: string()
    .nullable()
    .required(requiredTranslation)
    .email(translate(`validation.email`)),
});

export const privateCustomerAlternativeAddressSchema = object().shape({
  city: string().nullable().required(requiredTranslation),
  zipCode: string().nullable().required(requiredTranslation),
  address: string().nullable().required(requiredTranslation),
  lastName: string().nullable().required(requiredTranslation),
  firstName: string().nullable().required(requiredTranslation),
});

export const dropshipValidationSchema = object().shape({
  lastName: string().nullable().required(requiredTranslation),
  firstName: string().nullable().required(requiredTranslation),
  address: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      36,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.address').replace('*', '')
        )
        .replace('{1}', '36')
    ),
  zipCode: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      10,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.zipcode').replace('*', '')
        )
        .replace('{1}', '10')
    ),
  city: string()
    .nullable()
    .required(requiredTranslation)
    .max(
      36,
      translate('validation.too-long')
        .replace(
          '{0}',
          translate('checkout.customerinfo.city').replace('*', '')
        )
        .replace('{1}', '36')
    ),
  country: mixed()
    .nullable()
    .required(requiredTranslation)
    .notOneOf([''], requiredTranslation),
  phoneNumber: string().nullable().required(requiredTranslation),
  email: string()
    .nullable()
    .required(requiredTranslation)
    .email(translate(`validation.email`)),
  companyName: string()
    .nullable()
    .when('selectedDropshipAddressType', {
      is: CHECKOUT_DROPSHIP_COMPANY,
      then: (schema) => schema.required(requiredTranslation),
      otherwise: (schema) => schema.notRequired(),
    }),
});

export const businessCustomerDetailsSchema = object().shape({
  selectedDeliveryAddressId: string()
    .nullable()
    .required(requiredTranslation),
});
